export type InvitationEmailRow = {
  id: string;
  entityId: string;
  entityType: string;
  email: string;
};

export function planInvitationEmailRetarget(
  rows: InvitationEmailRow[],
  nextEmail: string
): { retargetIds: string[]; refreshIds: string[]; deleteIds: string[] } {
  const next = nextEmail.trim().toLowerCase();
  const retargetIds: string[] = [];
  const refreshIds: string[] = [];
  const deleteIds: string[] = [];

  const groups = new Map<string, InvitationEmailRow[]>();
  for (const row of rows) {
    const key = `${row.entityId}:${row.entityType}`;
    const list = groups.get(key);
    if (list) list.push(row);
    else groups.set(key, [row]);
  }

  for (const group of groups.values()) {
    const nextRow = group.find((row) => row.email.toLowerCase() === next);
    const previousRows = group.filter((row) => row.email.toLowerCase() !== next);
    if (nextRow) {
      refreshIds.push(nextRow.id);
      deleteIds.push(...previousRows.map((row) => row.id));
      continue;
    }
    if (previousRows[0]) {
      retargetIds.push(previousRows[0].id);
      deleteIds.push(...previousRows.slice(1).map((row) => row.id));
    }
  }

  return { retargetIds, refreshIds, deleteIds };
}

export function invitationEntityIdsForEmailSync(
  userId?: string | null,
  entityId?: string | null
): string[] {
  return [...new Set([userId, entityId].filter((id): id is string => Boolean(id)))];
}

export function invitationRowMatchesRetargetEmails(
  email: string,
  previousEmails: string[],
  nextEmail: string
): boolean {
  const value = email.trim().toLowerCase();
  const next = nextEmail.trim().toLowerCase();
  if (value && value === next) return true;
  return previousEmails.some((previous) => previous.trim().toLowerCase() === value);
}
